import { FULFILLMENT_TYPE } from '../constants/status';
import { getWindow } from './general';
/**
 * Checks productType to see if its a MA, if so, returns DirectDelivery, else returns STH
 * Logic validated by buybox team that own addToCart harmony component
 */
export var getBIAFulfillmentMethod = function (productType) {
    if (productType === 'MAJOR_APPLIANCE') {
        return FULFILLMENT_TYPE.DD;
    }
    if (productType === 'GIFT_CARD') {
        return FULFILLMENT_TYPE.STH;
    }
    return undefined;
};
/**
 * Checks and/or gets deliveryZip from experience context, else returns "DirectShip"
 */
export var getBIAFulfillmentLocation = function (productType) {
    var _a, _b;
    if (productType === 'GIFT_CARD' || productType === 'MAJOR_APPLIANCE') {
        return (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.__EXPERIENCE_CONTEXT__) === null || _b === void 0 ? void 0 : _b.deliveryZip;
    }
    return undefined;
};
